import { Skeleton } from '@/shared/ui/Skeleton';
import skeletonStyles from './TasksSkeleton.module.css';

export function TasksSkeleton() {
  return (
    <div className={skeletonStyles.container} data-testid="tasks-skeleton">
      {/* Title — single h1 line matching TasksHeader */}
      <Skeleton width={150} height={28} style={{ marginBottom: 'var(--spacing-8)' }} />

      {/* Task groups */}
      <div className={skeletonStyles.groupStack}>
        {[1, 2].map((section) => (
          <div key={section} className={skeletonStyles.groupStack}>
            {/* Group heading */}
            <Skeleton width={160} height={22} />
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-4)' }}>
              {[1, 2].map((card) => (
                <div key={card} className={skeletonStyles.card}>
                  <div className={skeletonStyles.cardMain}>
                    <Skeleton variant="circular" width={40} height={40} />
                    <div className={skeletonStyles.cardText}>
                      <Skeleton width="40%" height={18} />
                      <Skeleton width="20%" height={14} />
                    </div>
                  </div>
                  <Skeleton width={100} height={36} borderRadius="var(--radius-md)" />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
